import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from "./PageEditPanel.css";
import { AppAdminStore } from '../stores';
import { LocalizationService } from '../../../services/LocalizationService';
import { IAppComponent } from '../../../interfaces/IAppComponent';
import { IAIcon } from '../../icon/Icon';
import { IAGroup } from '../../group/Group';
import { IATextField } from '../../textField/TextField';
import { IAIconPicker } from '../../iconPicker/IconPicker';
import { IACommandBar } from '../../commandBar/CommandBar';
import { IAButton } from '../../button/Button';
import { IAPanel } from '../../panels';
import { TargetingService } from '../../../services/TargetingService';
import { IApplication, IDefaultValues } from '../../../interfaces/IApplication';
import { Utils } from '../../navigator/admin/Utils';
import { IAppPage } from '../../../interfaces/IAppPage';
import { TreeTargetingForGroups } from '../../treeTargetingForGroups';
import { TreeTargeting } from '../../treeTargeting';
import { Environment } from '../../../services/Environment';

export interface IProps {
  appAdminStore?: AppAdminStore;
  hasChanged?: () => void;
}

export interface IState {
}

@inject('appAdminStore')
@observer
export class PageEditPanel extends React.Component<IProps, IState> {

  private localizationService: LocalizationService = new LocalizationService();

  constructor(props: IProps) {
    super(props);
    this.state = {
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  componentDidMount(): void {
    TargetingService.getApplication(this.props.appAdminStore.environment, this.props.appAdminStore.tenant, this.props.appAdminStore.token, "App", false).then((applications) => {
      const applicationSettings = applications?.value[0];
      let application: IApplication;
      const appData = JSON.parse(applications?.value[0].defaultValues);
      let defaultValues: IDefaultValues;
      if (!appData || Array.isArray(appData)) {
        const list: any[] = [];
        defaultValues = {
          isEnable: false,
          type: "profileData",
          values: list,
          allValues: false
        };
        application = {
          id: undefined,
          title: applications?.value[0].title,
          name: applications?.value[0].title,
          instances: [],
          default: defaultValues
        };
      } else {
        application = appData;
        application.default.type = applications?.value[0].applicationSettings.toLocaleLowerCase() === "profile data" ? "profileData" : "userGroups";
      }
      applicationSettings.application = undefined;
      this.props.appAdminStore.applicationSettings = applicationSettings;
    });
  }

  public render(): JSX.Element {
    const content = [];
    let panelContent;
    let canAddMoreComponents = true;
    let selectedAppPage: IAppPage;
    if (this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex]) {
      selectedAppPage = this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex];
      if (this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components) {
        this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.forEach((component: IAppComponent, index) => {
          let icon;
          let iconUrl
          let text;
          switch (component.type) {
            case 'IntraActive-Messages':
              icon = 'Chat';
              text = this.localizationService.strings.AppAdmin_ComponentMessages;
              break;
            case 'IntraActive-Events':
              icon = 'Calendar';
              text = this.localizationService.strings.AppAdmin_ComponentEvents;
              break;
            case 'IntraActive-Phonebook':
              icon = 'Phone';
              text = this.localizationService.strings.AppAdmin_ComponentPhonebook;
              canAddMoreComponents = false;
              break;
            case 'IntraActive-Birthday':
              icon = 'Birthday';
              text = this.localizationService.strings.AppAdmin_ComponentBirthday;
              break;
            case 'IntraActive-ContentOrganizer':
              icon = 'Map';
              text = this.localizationService.strings.AppAdmin_ComponentContentMap;
              break;
            case 'EmbeddedPage':
              icon = 'Link';
              text = this.localizationService.strings.AppAdmin_ComponentEmbeddedPage;
              canAddMoreComponents = false;
              break;
            case 'ExternalLink':
              icon = 'LinkExternal';
              text = this.localizationService.strings.AppAdmin_ComponentExternalLink;
              canAddMoreComponents = false;
              break;
            case 'IntraActive-NavigatorAdmin':
              icon = 'Compass';
              text = this.localizationService.strings.AppAdmin_ComponentNavigator;
              canAddMoreComponents = false;
              break;
            case 'IntraActive-ContentOrganizerPortal':
              icon = 'Mind map';
              text = this.localizationService.strings.AppAdmin_ContentOrganizerPortal;
              canAddMoreComponents = false;
              break;
            case 'Sharepoint-News':
              iconUrl = 'https://intraactivestorage.blob.core.windows.net/cdn/extra%2520icons/ic_sharepoint.svg';
              text = this.localizationService.strings.AppAdmin_ComponentSharepointNews;
              break;
            case 'IntraActive-AIAssistant':
              iconUrl = "https://intraactivestorage.blob.core.windows.net/cdn/icons/Bot/SVG/ic_fluent_bot_24_regular.svg";
              text = this.localizationService.strings.AppAdmin_AIAssistant;;
              break;
            default:
              break;
          }
          content.push(
            <div
              className={styles.IA_pageComponent}
              key={`pageComponent_${index}`}
            >
              {(icon || iconUrl) &&
                <IAIcon
                  title={icon}
                  url={iconUrl}
                  size={18}
                  color={"#333333"}
                  style={{
                    float: "left",
                    marginTop: 16,
                    marginLeft: 16
                  }}
                />
              }
              <div
                className={styles.IA_pageComponentText}
              >
                {text}
              </div>
              <div
                className={styles.IA_icon}
                style={{
                  float: "right",
                  marginRight: 20,
                  cursor: "pointer"
                }}
                onClick={() => {
                  this.props.appAdminStore.selectedComponentIndex = index;
                  setTimeout(() => {
                    this.props.appAdminStore.editComponent = true;
                  }, 500);
                }}
              >
                <IAIcon
                  title={"Edit"}
                  size={18}
                  color="#23879b"
                />
              </div>
              <div
                className={styles.IA_icon}
                style={{
                  float: "right",
                  marginRight: 10
                }}
                onClick={() => {
                  this.props.appAdminStore.componentIndexToDelete = index;
                }}
              >
                <IAIcon
                  title={"Trash"}
                  size={18}
                  color="#23879b"
                />
              </div>
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg"
                size={18}
                color={index < this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.length - 1 ? "#23879b" : "#eeeeee"}
                onClick={() => {
                  if (index < this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.length - 1) {
                    var element = this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components[index];
                    this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.splice(index, 1);
                    this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.splice(index + 1, 0, element);
                    this.props.appAdminStore.checkForChanges();
                    this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index < this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.length - 1 ? "pointer" : "default"
                }}
              />
              <IAIcon
                url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"
                size={18}
                color={index > 0 ? "#23879b" : "#eeeeee"}
                onClick={() => {
                  if (index > 0) {
                    var element = this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components[index];
                    this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.splice(index, 1);
                    this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].components.splice(index - 1, 0, element);
                    this.props.appAdminStore.checkForChanges();
                    this.props.hasChanged();
                  }
                }}
                style={{
                  float: "right",
                  marginTop: 16,
                  marginRight: 16,
                  cursor: index > 0 ? "pointer" : "default"
                }}
              />
            </div>
          );
        });
      }
      let selectedValues = undefined;
      if (selectedAppPage !== undefined && selectedAppPage.targeting !== undefined && this.props.appAdminStore.applicationSettings) {
        selectedValues = Utils.parseSelectedTargetingValues(selectedAppPage.targeting, this.props.appAdminStore.applicationSettings?.applicationSettings);
      }
      panelContent = (
        <div
          className={styles.IA_editPanel}
          id="IA_PageEditPanel"
        >
          <IAGroup
            label={this.localizationService.strings.AppAdmin_MenuItemDesign}
          >
            <IATextField
              label={this.localizationService.strings.AppAdmin_PageTitle}
              text={this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].title}
              onChange={(title: string) => {
                if (this.props.appAdminStore.instance?.settings) {
                  this.props.appAdminStore.instance.settings.menu[this.props.appAdminStore.selectedPageIndex].title = title;
                }
                this.props.appAdminStore.checkForChanges();
                if (this.props.hasChanged) {
                  this.props.hasChanged();
                }
              }}
            />
            <IAIconPicker
              label={this.localizationService.strings.AppAdmin_Icon}
              selectedIcon={this.props.appAdminStore.instance?.settings?.menu[this.props.appAdminStore.selectedPageIndex].icon}
              color={"#23879b"}
              select={(icon: string) => {
                if (this.props.appAdminStore.instance?.settings) {
                  this.props.appAdminStore.instance.settings.menu[this.props.appAdminStore.selectedPageIndex].icon = icon;
                }
                this.props.appAdminStore.checkForChanges();
                if (this.props.hasChanged) {
                  this.props.hasChanged();
                }
              }}
              shouldBeAbleToClear={false}
              clear={() => { }}
            />
            <div style={{
              marginTop: 10,
              float: "left"
            }}
            >
              {(this.props.appAdminStore.applicationSettings && this.props.appAdminStore.applicationSettings?.applicationSettings?.toLowerCase() !== "profile data") ?
                <TreeTargetingForGroups
                  environment={this.props.appAdminStore.environment}
                  tenant={this.props.appAdminStore.tenant}
                  application={"app"}
                  applicationData={this.props.appAdminStore.applicationSettings}
                  instance={this.props.appAdminStore.instance?.instanceName}
                  selectedGroupIds={selectedAppPage?.targeting?.targetingGroups}
                  showTarget={selectedAppPage.targeting ? selectedAppPage.targeting.enabled : false}
                  highlightColor={"red"}
                  onShowTargetChanged={(showTarget: boolean) => {
                    if (!selectedAppPage.targeting) {
                      selectedAppPage.targeting = {
                        enabled: showTarget,
                        operator: "OR"
                      };
                    } else {
                      selectedAppPage.targeting.enabled = showTarget;
                    }
                    if (this.props.hasChanged) {
                      this.props.hasChanged();
                    }
                  }}
                  onGroupIdsUpdated={(ids: number[]) => {
                    selectedAppPage.targeting.targetingGroups = ids;
                    this.props.appAdminStore.checkForChanges();
                    if (this.props.hasChanged) {
                      this.props.hasChanged();
                    }
                  }}
                />
                :
                <TreeTargeting
                  application={"app"}
                  environment={this.props.appAdminStore.environment}
                  tenant={this.props.appAdminStore.tenant}
                  applicationData={this.props.appAdminStore.applicationSettings}
                  instance={this.props.appAdminStore.instance?.instanceName}
                  authToken={this.props.appAdminStore.token}
                  apiUrl={Environment.getEnvironmentForMainAPI(this.props.appAdminStore.environment)}
                  selectedValues={selectedValues}
                  operator={selectedAppPage.targeting ? selectedAppPage.targeting.operator : "OR"}
                  showTarget={selectedAppPage.targeting ? selectedAppPage.targeting.enabled : false}
                  currenNodeStructure={selectedAppPage.targetingExistingStructure}
                  onShowTargetChanged={(showTarget: boolean) => {
                    if (!selectedAppPage.targeting) {
                      selectedAppPage.targeting = {
                        enabled: showTarget,
                        operator: "OR"
                      };
                    } else {
                      selectedAppPage.targeting.enabled = showTarget;
                    }
                    if (this.props.hasChanged) {
                      this.props.hasChanged();
                    }
                  }}
                  onChange={(targeting, applicationSettings, groups, _selectAll, targetingExistingStructure) => {
                    console.log(applicationSettings);
                    console.log(targetingExistingStructure);
                    // Processing targeting values
                    if (targeting) {
                      selectedAppPage.targeting.targetingFields = Utils.processReturnTreeTargeting(targeting);
                    }

                    // Processing targeting group data
                    if (groups) {
                      selectedAppPage.targeting.groupData = JSON.stringify(groups);
                      selectedAppPage.targeting.targetingGroups = [];

                      if (groups.length > 0) {
                        groups.forEach((x) => {
                          selectedAppPage.targeting.targetingGroups.push(x.id.toString());
                        });
                      }
                    }

                    // if (this.props.appAdminStore.smartmenuTopItemIndexToEdit !== undefined) {
                    //   this.props.navigatorStore.updateSmartmenuTopIteTargeting(selectedAppPage.targeting);
                    // } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                    //   this.props.navigatorStore.updateTargeting(selectedAppPage.targeting);
                    // }

                    // this.setState({ applicationSettings: applicationSettings });
                    // this.props.navigatorStore.applicationSettings = applicationSettings;
                    // selectedAppPage.targetingExistingStructure = targetingExistingStructure;
                    // this.props.navigatorStore.checkForChanges(); 
                    this.props.appAdminStore.checkForChanges();
                    if (this.props.hasChanged) {
                      this.props.hasChanged();
                    }
                  }}
                  highlightColor={"red"}
                  onLogicalOperatorChanged={(operator: string) => {
                    selectedAppPage.targeting.operator = operator;
                    // if (this.props.navigatorStore.smartmenuTopItemIndexToEdit !== undefined) {
                    //   this.props.navigatorStore.updateSmartmenuTopIteTargeting(selectedAppPage.targeting);
                    // } else if (this.props.navigatorStore.topItemIndexToEdit !== undefined) {
                    //   this.props.navigatorStore.updateTargeting(selectedAppPage.targeting);
                    // }
                  }}
                  nodeComparison={"label"}
                />
              }
            </div>
          </IAGroup>
          <IAGroup
            label={this.localizationService.strings.AppAdmin_MenuItemContent}
          >
            {content}
            {canAddMoreComponents &&
              <IACommandBar
                highlightColor={"#23879b"}
                leftSideContent={
                  <div>
                    <IAButton
                      label={this.localizationService.strings.AppAdmin_Add}
                      buttonColor="transparent"
                      textColor="#333333"
                      icon="Add"
                      height={22}
                      iconColor={"#23879b"}
                      fontSize={14}
                      onClick={() => {
                        this.props.appAdminStore.createNewItem();
                      }}
                      style={{ float: "left" }}
                    />
                  </div>
                }
                showBar={true}
              />
            }
          </IAGroup>
        </div>
      );
    }
    return (
      <IAPanel
        showNavigationBar={true}
        component={"AppAdmin"}
        open={!!this.props.appAdminStore.editPage && !this.props.appAdminStore.editComponent}
        transition="slide"
        width={600}
        isMobile={false}
        highlightColor={"#23879b"}
        overlayColor={"transparent"}
        marginTop={location.origin.indexOf("sharepoint.com") !== -1 ? 159 : 50}
        disableSaving={this.props.appAdminStore.isSaving}
        close={() => {
          this.props.appAdminStore.editPage = false;
        }}
        onDelete={this.props.appAdminStore.instance?.settings?.menu.length > 1 ? () => {
          this.props.appAdminStore.pageIndexToDelete = this.props.appAdminStore.selectedPageIndex;
          this.props.appAdminStore.checkForChanges();
          if (this.props.hasChanged) {
            this.props.hasChanged();
          }
        } : undefined}
      >
        {panelContent}
      </IAPanel>
    );
  }

}